import { CakeRequestManager } from '../lib';

export class CakeApiBase {
  protected requestManager: CakeRequestManager;

  constructor(requestManager: CakeRequestManager) {
    this.requestManager = requestManager;
  }
}
